/**
 * AboutCard - App version and description
 */
export default function AboutCard({ version = '1.8.1' }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>About</h3>
      </div>
      <div className="card-body">
        <div className="space-y-2 text-sm" style={{ color: 'var(--color-text-secondary)' }}>
          <p>
            <strong>Mytineri</strong> — Your itinerary, always within reach. A calm, offline-first travel companion.
          </p>
          <p>
            Built with React, Cloudflare Workers, and D1 database.
          </p>
          <p style={{ color: 'var(--color-text-muted)' }}>
            Version {version}
          </p>
        </div>
      </div>
    </div>
  );
}
